import React, { useEffect, useState } from "react";
import ReactDOMServer from "react-dom/server";
import Chart from "react-google-charts";
import moment from "moment";

const columns = ["Date", "Scans", { role: "tooltip", p: { html: true } }];

const options = {
    animation: {
        duration: 1500,
        easing: "out",
        startup: true,
    },
    axisTitlesPosition: "none",
    hAxis: {
        textStyle: {
            fontSize: 14,
        },
        gridlines: {
            color: "transparent",
        },
        baselineColor: "#fff",
    },
    legend: {
        position: "none",
    },
    series: {
        0: { color: "#0a7087" },
    },
    title: "",
    tooltip: {
        isHtml: true,
    },
    vAxis: {
        minorGridlines: { count: 0 },
        gridlines: {
            color: "transparent",
        },
        baselineColor: "#fff",
        textPosition: "none",
    },
    chartArea: {
        width: "100%",
    },
};

const showTooltip = (currentDate: any, count: any) => {
    return ReactDOMServer.renderToString(
        <div style={{ padding: "0.5rem" }}>
            <span style={{ fontSize: 12, fontWeight: 400, textTransform: "uppercase" }}>{moment(currentDate).format("MMMM DD, YYYY")}</span>
            <div style={{ padding: "5px 0px" }}>
                <span>
                    <span>
                        <em className="las la-circle" style={{ background: "#0a7087", borderRadius: "50%" }}></em>
                    </span>
                    <span style={{ fontSize: 14, fontWeight: 800, paddingLeft: 5 }}>Scans</span>
                </span>
                <span style={{ fontSize: 16, fontWeight: 400, paddingLeft: "1rem" }}>{count}</span>
            </div>
        </div>
    );
};
const getDaysWithRowCount = function (year: any, month: any, scanRow: any) {
    let monthIndex = month - 1;
    let date = new Date(year, monthIndex, 1);
    const result = [];
    while (date.getMonth() === monthIndex) {
        if (date && date.getDate()) {
            const currentData = scanRow.find((current: any) => {
                return date.getDate().toString() === moment(current.date, "YYYY/MM/DD").format("D");
            });
            if (currentData) {
                result.push([date.getDate().toString(), currentData.count, showTooltip(currentData.date, currentData.count)]);
            } else {
                result.push([date.getDate().toString(), 0, showTooltip(date, 0)]);
            }
            date.setDate(date.getDate() + 1);
        }
    }
    return result;
};
function MavDailyScans({ childScanReport, scanLoading, isError }: any) {
    const [rows, setRows] = useState<any>([]);
    useEffect(() => {
        if (childScanReport && childScanReport.length) {
            const date = moment(childScanReport[0]["date"], "YYYY/MM/DD");
            setRows(getDaysWithRowCount(date.format("YYYY"), date.format("M"), childScanReport));
        }
    }, [childScanReport]);

    return !scanLoading && ((childScanReport && childScanReport.length === 0) || isError) ? null : (
        <div className="row">
            <div className="col-xs">
                <div className={scanLoading ? "box offset-padding loading" : "box offset-padding"}>
                    <div className="box-header">
                        <div className="box-title-container">
                            <div className="box-title-icon">
                                <div className="scan-msg-icon">
                                    <span role="img" aria-label="Scanning" className="">
                                        <svg width="32px" height="32px" viewBox="0 0 16 16" version="1.1">
                                            <g id="scan" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                <path
                                                    d="M8,0 C10.1366482,0 12.1462517,0.832486961 13.6561002,2.34296161 C13.7975008,2.48339695 13.8740246,2.67196176 13.8740246,2.86740049 C13.8740246,3.06223098 13.797303,3.25063899 13.6568017,3.39114029 L13.6568017,3.39114029 L9.98245783,7.0646747 L10.0287745,7.16583481 C10.1150888,7.37585519 10.1681937,7.59857289 10.1859831,7.82735202 L10.1859831,7.82735202 L10.1926705,7.99996919 C10.1926705,9.20909636 9.20898806,10.1927788 7.9998609,10.1927788 C6.79073374,10.1927788 5.80705125,9.20909636 5.80705125,7.99996919 C5.80705125,6.79085195 6.79075466,5.80715955 7.9998609,5.80715955 C8.28987743,5.80715955 8.57282763,5.86314888 8.83518524,5.97117504 L8.83518524,5.97117504 L8.93455422,6.016 L9.97706024,4.97426506 L9.91185529,4.93116797 C9.39962381,4.6104338 8.81580275,4.42501429 8.2045738,4.39113772 L8.2045738,4.39113772 L7.99987632,4.3854805 C6.00716829,4.3854805 4.38549558,6.00715321 4.38549558,7.99986124 C4.38549558,9.99256928 6.00716829,11.614242 7.99987632,11.614242 C9.99258436,11.614242 11.6142571,9.99256928 11.6142571,7.99986124 C11.6142571,7.59076493 11.9461265,7.25889546 12.3552228,7.25889546 C12.7643192,7.25889546 13.0961886,7.59076493 13.0961886,7.99986124 C13.0961886,10.8102376 10.8101601,13.0962661 7.99978379,13.0962661 C5.18940746,13.0962661 2.90337895,10.8102376 2.90337895,7.99986124 C2.90337895,5.18948492 5.18940746,2.9034564 7.99978379,2.9034564 C9.03714943,2.9034564 10.030493,3.2120007 10.8718929,3.78875119 L10.8718929,3.78875119 L11.0403855,3.91016867 L12.0543614,2.89619277 L11.883814,2.7641494 C10.8352865,1.9823367 9.58411201,1.53929734 8.26459045,1.48697138 L8.26459045,1.48697138 L7.99981463,1.48173109 C4.40587292,1.48173109 1.48168479,4.4059194 1.48168479,7.99986124 C1.48168479,11.593803 4.40587286,14.5179911 7.99981463,14.5179911 C11.5937565,14.5179911 14.5179448,11.593803 14.5179448,7.99986124 C14.5179448,7.59076493 14.8498143,7.25889546 15.2590714,7.2588955 C15.6681962,7.25912307 16,7.59093442 16,8 C16,10.1363645 15.1675765,12.1460272 13.6568103,13.6567934 C12.1461394,15.1675921 10.1364509,16 8,16 C5.8636352,16 3.85397253,15.1675767 2.34316413,13.6567684 C0.832626582,12.1457346 0,10.1359128 0,8 C0,5.86417402 0.832642077,3.85437812 2.34318905,2.34320671 C3.85385999,0.832407808 5.86354845,0 8,0 Z M8,7 C7.44771525,7 7,7.44771525 7,8 C7,8.55228475 7.44771525,9 8,9 C8.55228475,9 9,8.55228475 9,8 C9,7.44771525 8.55228475,7 8,7 Z"
                                                    id="Combined-Shape"
                                                    fill="#00313C"
                                                    fillRule="nonzero"
                                                ></path>
                                            </g>
                                        </svg>
                                    </span>
                                </div>
                            </div>
                            <div className="box-title-text">
                                <h2 className="box-title">Daily Scans</h2>
                            </div>
                        </div>

                        {rows.length > 0 && (
                            <div className="box-description">
                                <div id="mal-daily-scans-chart" className="row">
                                    <Chart options={options} chartType="ColumnChart" height="200px" width="100%" data={[columns, ...rows]}
                                    chartEvents={[
                                        {
                                            eventName: "ready",
                                            callback: ({ chartWrapper, google }) => {
                                                var chart = new google.visualization.ColumnChart(document.getElementById("mal-daily-scans-chart"));
                                                setTimeout(() => {
                                                    var svg = chart.getContainer().getElementsByTagName('svg');
                                                    if (svg.length > 0) {
                                                        svg[0].setAttribute('aria-label', 'Transaction Activity Bar Graph');
                                                        svg[0].setAttribute('role', 'img');
                                                    }
                                                }, 3000);
                                            },
                                        },
                                    ]}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MavDailyScans;
